import React from "react";
import MarketItem from "../../../molecules/marketItens";
import "./index.css";


const MarketCentral = () => {
    return (
        <main>
            <MarketItem/>
        </main>
    )
}

export default MarketCentral